<template>
  <div class="loyalty-help container">
    <h2>{{ heading }}</h2>
    <div class="slot"><slot /></div>
    <div class="view-faqs-button">
      <Button tag="a" full-width theme="primary" href="/pages/help">
        VIEW FAQS
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "LoyaltyHelp",
  components: {
    Button,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.loyalty-help {
  margin-bottom: 30px;
  @include respond-above(md) {
    margin-bottom: 80px;
  }
}

h2 {
  display: flex;
  font-family: $heading-font-family;
  font-size: 28px;
  font-weight: 400;
  justify-content: center;
  margin-bottom: 10px;
  @include respond-above(md) {
    font-size: 50px;
    margin: 0 auto 20px;
    max-width: 450px;
  }
}

.slot {
  ::v-deep(p) {
    font-family: $body-font-family;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 30px;
    text-align: center;
    @include respond-above(md) {
      margin: 0 auto 30px;
      max-width: 450px;
    }
  }
}

.view-faqs-button {
  @include respond-above(md) {
    margin: 0 auto;
    max-width: 300px;
  }
}
</style>
